import { render, staticRenderFns } from "./table.vue?vue&type=template&id=286c41ed&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=286c41ed&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286c41ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('286c41ed')) {
      api.createRecord('286c41ed', component.options)
    } else {
      api.reload('286c41ed', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=286c41ed&scoped=true", function () {
      api.rerender('286c41ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/table.vue"
export default component.exports